import { render, staticRenderFns } from "./IconRightTop1.vue?vue&type=template&id=70bd73c9&"
import script from "./IconRightTop1.vue?vue&type=script&lang=js&"
export * from "./IconRightTop1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bd73c9')) {
      api.createRecord('70bd73c9', component.options)
    } else {
      api.reload('70bd73c9', component.options)
    }
    module.hot.accept("./IconRightTop1.vue?vue&type=template&id=70bd73c9&", function () {
      api.rerender('70bd73c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightTop1.vue"
export default component.exports